export const envPicker = () => {
  const { hostname } = window.location

  let currentEnv = ''
  if (hostname.includes('.local.')) currentEnv = 'local'
  else if (hostname.includes('.s.') || hostname.includes('.e.')) currentEnv = 'staging'
  else currentEnv = 'production'

  return currentEnv
}
